import Vue from 'vue'

/**
 * @author Mariela T. TL <mariela.temozihui@jbge.com.mx>
 *
 *
 * Upload invoice
 *
 * @return {Object}
 */

const uploadInvoiceOrder = (payload) =>
  Vue.$http.post(`purchase/buy_order_invoice/`, payload)
    .then(response => {
      return response.data
    })
    .catch(err => { throw err })

export default uploadInvoiceOrder



// WEBPACK FOOTER //
// ./src/services/purchase/uploadInvoiceOrder.js